export default __webpack_public_path__ + "static/media/Ballroll_00194.4764b45f.png";